module.exports = __webpack_public_path__ + "img/25.062203ba.jpg";